var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var IconWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: ", ";\n  & svg {\n    path {\n      fill: ", "\n    }\n\n    :hover {\n      path {\n        fill: ", ";\n      }\n    }\n\n    :active {\n      path {\n        fill: ", ";\n      }\n    }\n  }\n"], ["\n  cursor: ", ";\n  & svg {\n    path {\n      fill: ", "\n    }\n\n    :hover {\n      path {\n        fill: ", ";\n      }\n    }\n\n    :active {\n      path {\n        fill: ", ";\n      }\n    }\n  }\n"])), function (_a) {
    var hoverDisabled = _a.hoverDisabled;
    return hoverDisabled ? 'auto' : 'pointer';
}, function (_a) {
    var icon = _a.theme.icon, pressed = _a.pressed;
    return pressed ? icon.active : icon.default;
}, function (_a) {
    var theme = _a.theme, hoverDisabled = _a.hoverDisabled;
    return hoverDisabled ? theme.icon.default : theme.icon.hover;
}, function (_a) {
    var theme = _a.theme, hoverDisabled = _a.hoverDisabled;
    return hoverDisabled ? theme.icon.default : theme.icon.active;
});
var templateObject_1;
//# sourceMappingURL=styles.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var IconWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: ", ";\n  & svg {\n    path {\n      fill: ", "\n    }\n\n    :hover {\n      path {\n        fill: ", ";\n      }\n    }\n\n    :active {\n      path {\n        fill: ", ";\n      }\n    }\n  }\n"], ["\n  cursor: ", ";\n  & svg {\n    path {\n      fill: ", "\n    }\n\n    :hover {\n      path {\n        fill: ", ";\n      }\n    }\n\n    :active {\n      path {\n        fill: ", ";\n      }\n    }\n  }\n"])), function (_a) {
    var hoverDisabled = _a.hoverDisabled;
    return hoverDisabled ? 'auto' : 'pointer';
}, function (_a) {
    var icon = _a.theme.icon, pressed = _a.pressed;
    return pressed ? icon.active : icon.default;
}, function (_a) {
    var theme = _a.theme, hoverDisabled = _a.hoverDisabled;
    return hoverDisabled ? theme.icon.default : theme.icon.hover;
}, function (_a) {
    var theme = _a.theme, hoverDisabled = _a.hoverDisabled;
    return hoverDisabled ? theme.icon.default : theme.icon.active;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map